<template>
  <span class="tag">
    <slot></slot>
  </span>
</template>

<script>
  export default {
    name: 'tag',
  }
</script>

<style scoped lang="scss">
  .tag {
    display: flex;
    align-items: center;
    font-size: 16px;
    line-height: 1.4;
    color: #383838;
    margin: 0 10px;
    font-family: "Open Sans", sans-serif;
    &:before {
     content: '';
     display: block;
     width: 10px;
     height: 10px;
     background: #DBBFA7;
     border-radius: 50%;
     margin-right: 10px;
    }
  }
</style>
